@if (autotext) {
	<div style="padding: 25px">
		<div class="d-flex align-items-end gap-5">
			<div class="flex-grow-1">
				<label>{{ "name" | langVal }}</label>
				<app-gen-input
					tabindex="1"
					[actualObj]="autotext"
					[errors]="errors"
					fieldName="name"
					(changeEvent)="validateAndSave('name')"
				>
				</app-gen-input>
			</div>
			@if (autotext.id) {
				<!--        <app-btn-ext btnClass="btn btn-icon" text="delete" (clickEv)="delete()" [isSpin]="isSaving" />-->
				<button
					(click)="isModalOpen = true"
					class="btn btn-icon"
					titleLang="remove_invoiceline"
					icon="delete"
					isSpin="isSaving"
				></button>
			}
		</div>

		<!-- <div class="row"> -->
		<div class="form-group">
			<label class="html_autotext">{{ "html_autotext" | langVal }}</label>
			<app-wysiwyg
				tabindex="-1"
				[actualObj]="autotext"
				[errors]="errors"
				fieldName="html_autotext"
				(changeEvent)="validateAndSave('html_autotext')"
			>
			</app-wysiwyg>
		</div>
		<!-- </div> -->

		<!-- <div class="row">
			<div class="colstat colstat-medium">
				<label>{{ "active" | langVal }}</label>
				<app-gen-button-group
					[actualObj]="autotext"
					fieldName="active"
					optionsListName="yes_no_opts"
					(changeEvent)="validateAndSave('active')"
				/>
			</div>
		</div> -->
	</div>

	<div class="modal-btns">
		<app-btn-ext
			text="exit"
			(clickEv)="onClose.emit()"
		/>
		@if (!autotext.id) {
			<app-btn-ext
				text="add"
				(clickEv)="save()"
				[isSpin]="isSaving"
				[disabled]="!isFormSubmittable"
			/>
		}
	</div>
}
@if (isModalOpen) {
	<app-modal-wrap
		(onClose)="isModalOpen = false"
		title="do_you_confirm_delete"
		modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
	>
		<app-confirm
			(onClose)="isModalOpen = false; $event && delete()"
			[objectName]="autotext.name"
		/>
	</app-modal-wrap>
}
